(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for one agenda appointment -> displayed in historie list
    module.directive('agendaAppointmentHistorieItem', [function () {
        var directive = {
            restrict: 'A',
            templateUrl: '/app/agenda/templates/agenda-appointment-historie-item.template.html',
            controller: 'AgendaAppointmentHistorieItemController',
            controllerAs: 'vm',
            scope: {
                appointment: '='
            },
            bindToController: true
        };
        return directive;       
    }]);

})();